import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Info from "@insite/mobius/Icons/Info";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface MinimumOrderQtyStyles {
    wrapper?: InjectableCss;
}

export const minimumOrderQtyStyles: MinimumOrderQtyStyles = {
    wrapper: {
        css: css`
            color: #ef3742;
            font-size: 10px;
            font-style: italic;
        `,
    },
};

const styles = minimumOrderQtyStyles;

interface OwnProps {
    minimumOrderQuantity: number;
}

type props = OwnProps;

const MinimumOrderQtyComponent: React.FC<props> = ({ minimumOrderQuantity }) => {
    return (
        <StyledWrapper className="minimumOrderQty" {...styles.wrapper}>
            Enter in multiples of {minimumOrderQuantity}
        </StyledWrapper>
    );
};

export default MinimumOrderQtyComponent;
